// extracted by mini-css-extract-plugin
export var content = "CourseDetailHeader-module--content--c2630";
export var holder = "CourseDetailHeader-module--holder--552f3";
export var subTitle = "CourseDetailHeader-module--sub-title--e6e0f";
export var title = "CourseDetailHeader-module--title--f9385";
export var wrapper = "CourseDetailHeader-module--wrapper--92456";